<template>
  <div class="w-full">
    <!-- 投放时间段 -->
    <schedule-time
      v-if="formKey === 'time_period'"
      ref="schedule_time_ref"
      :is-preview="formItem.isPreview"
      :is-hour="!!formItem.isHour"
      preele="step-form-scrollbar-wrapper"
      :value="formItem.value"
    />
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';

export default {
  components: {
    'schedule-time': () => import('@/components/schedule-time'),
  },
  props: {
    ...component_props,
  },
};
</script>
